import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Society } from '../models/society.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SocietyService {

  constructor(private http: HttpClient) {}

  getAllSocieties(): Observable<Society[]> {
    return this.http.get<Society[]>(environment.api_service_societies);
  }

  getSocietyById(id: string): Observable<Society> {
    return this.http.get<Society>(`${environment.api_service_societies}/${id}`);
  }

  createSociety(society: Society): Observable<Society> {
    return this.http.post<Society>(environment.api_service_societies, society);
  }

  updateSociety(id: string, society: Society): Observable<Society> {
    return this.http.put<Society>(`${environment.api_service_societies}/${id}`, society);
  }

  deleteSociety(id: string): Observable<void> {
    return this.http.delete<void>(`${environment.api_service_societies}/${id}`);
  }
}
